"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var RelayHooksTypes_1 = require("./RelayHooksTypes");

var useOssFragment_1 = require("./useOssFragment");

function usePagination(fragmentNode, fragmentRef) {
  var data = useOssFragment_1.useOssFragment(fragmentNode, fragmentRef, false, RelayHooksTypes_1.PAGINATION_NAME)[0];
  return data;
}

exports.usePagination = usePagination;

function usePaginationFragment(fragmentNode, fragmentRef) {
  var data = useOssFragment_1.useOssFragment(fragmentNode, fragmentRef, true, RelayHooksTypes_1.PAGINATION_NAME)[0];
  return data;
}

exports.usePaginationFragment = usePaginationFragment;